class SmartStatementsController {
  /*@ngInject*/
  constructor($scope, $mdDialog, smartStatementsRepository, attachmentsRepository) {
    this.name = 'enquiry-details-smart-statements'
    this.$scope = $scope
    this.$mdDialog = $mdDialog
    this.smartStatementsRepository = smartStatementsRepository
    this.attachmentsRepository = attachmentsRepository
    this.led = {}
  }

  $onInit() {
    this.loanEnquiry.promise('loanEnquiryDetails').then(() => {
      this.$scope.$watch(() => this.loanEnquiry.loanEnquiryDetails, (loanEnquiryDetails) => {
        if (loanEnquiryDetails && Array.isArray(loanEnquiryDetails) && loanEnquiryDetails.length > 0) {
          this.bankStatements = this._uploadedFiles(loanEnquiryDetails, 'electronicBankStatements.bankStatements')
          this.lastBankStatementDate = this._lastUpload(this.bankStatements)?.attachment?.createdAt
          this.smartStatements = this._uploadedFiles(loanEnquiryDetails, 'electronicBankStatements.smartStatements')
          this.lastSmartStatementDate = this._lastUpload(this.bankStatements)?.attachment?.createdAt
        }
      })
    })
    this.businessName = this.loanEnquiry.loanEnquirySummary.borrower.businessName || 'Borrower'
  }

  get canSubmit() {
    this.lastBankStatementDate = this._lastUpload(this.bankStatements)?.attachment?.createdAt
    this.lastSmartStatementDate = this._lastUpload(this.smartStatements)?.attachment?.createdAt
    return this.bankStatements?.length > 0 && (!this.lastSmartStatementDate || this.lastBankStatementDate > this.lastSmartStatementDate)
  }

  submit() {
    return this._confirmSubmit(this.businessName).then(() => {
      this.requestedSmartStatements = true
      return this._performSubmit()
    })
  }

  // private

  _lastUpload(statements) {
    let lastUpload = null
    let date = ''
    statements?.forEach((uploads) => {
      uploads?.forEach((upload) => {
        if (upload.attachment?.createdAt > date) {
          date = upload.attachment.createdAt
          lastUpload = upload
        }
      })
    })
    return lastUpload
  }

  _confirmSubmit(name) {
    return this.$mdDialog.show(
      this.$mdDialog.confirm().textContent(`Are you sure you want to request a smart statement for "${name}"?`)
        .clickOutsideToClose(true)
        .title(`Request smart statement?`)
        .ariaLabel('Submit request?')
        .ok('Do it')
        .cancel('Cancel')
    )
  }

  _performSubmit() {
    this.$mdDialog.show({
      template: `
        <md-dialog flex="50">
          <md-dialog-content layout-padding layout="column" layout-align="center center">
            <h2>Processing request</h2> 
            <md-progress-circular md-mode="indeterminate" md-diameter="200"></md-progress-circular>
          </md-dialog-content>
        </md-dialog>
      `,
      escapeToClose: false,
      clickOutsideToClose: false
    })

    const payload = {
      reference: this._lastUpload(this.bankStatements)?.loanEnquiryDetail?.id
    }
    return this.smartStatementsRepository.create(payload)
      .finally(() => this.$mdDialog.hide())
  }

  _uploadedFiles(loanEnquiryDetails, type) {
    let files = []
    loanEnquiryDetails.forEach((loanEnquiryDetail) => {
      loanEnquiryDetail.response.enquiryDetails?.filter((qanda) => qanda.name === 'upload' || qanda.type === 'FileUpload').forEach((qanda) => {
        if (qanda.answer.uploads && Array.isArray(qanda.answer.uploads) && qanda.answer.uploads.length > 0) {
          if (qanda.name.includes(type)) {
            const uploads = qanda.answer.uploads
            uploads.forEach(upload => {
              upload.loanEnquiryDetail = loanEnquiryDetail
              this.attachmentsRepository.getById(upload.attachmentId).then(attachment => upload.attachment = attachment)
            })
            files.push(uploads)
          }
        }
      })
    })
    return files
  }
}

export default SmartStatementsController
